import React, { useState, useEffect, createContext, useContext, ReactNode } from 'react';
export type Language = 'en' | 'es' | 'ht' | 'vi';
interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
const STORE_KEY = 'noor_lang';
const VALID: Language[] = ['en', 'es', 'ht', 'vi'];
// Recuerda el idioma elegido (para que al volver de Stripe a /gracias el cliente
// vea la página en su idioma). Si el navegador no permite guardar, queda en inglés como antes.
function readStoredLanguage(): Language {
  try {
    const v = window.localStorage.getItem(STORE_KEY) as Language | null;
    if (v && VALID.includes(v)) return v;
  } catch {
    /* sin almacenamiento */
  }
  return 'en';
}
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>(readStoredLanguage);
  // Keep the document's language in sync with the selected language. This lets
  // screen readers pronounce each language correctly (essential for our
  // multilingual audience) and helps search engines understand the page.
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = language;
    }
    try {
      window.localStorage.setItem(STORE_KEY, language);
    } catch {
      /* sin almacenamiento */
    }
  }, [language]);
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-485" data-mp="2yyrj4q1lqraw">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}
export const LANGUAGES: {
  code: Language;
  label: string;
  short: string;
}[] = [{
  code: 'en',
  label: 'English',
  short: 'EN'
}, {
  code: 'es',
  label: 'Español',
  short: 'ES'
}, {
  code: 'ht',
  label: 'Kreyòl Ayisyen',
  short: 'HT'
}, {
  code: 'vi',
  label: 'Tiếng Việt',
  short: 'VI'
}];